'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimePeriodLabel = exports.getReportedTimePeriodNote = exports.getReportedTimePeriod = exports.getReportedTimePeriodLabel = exports.getLocale = exports.dateWithoutTZ = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _dateFns = require('date-fns');

var _dateFns2 = _interopRequireDefault(_dateFns);

var _fr = require('date-fns/locale/fr');

var _fr2 = _interopRequireDefault(_fr);

var _de = require('date-fns/locale/de');

var _de2 = _interopRequireDefault(_de);

var _en = require('date-fns/locale/en');

var _en2 = _interopRequireDefault(_en);

var _es = require('date-fns/locale/es');

var _es2 = _interopRequireDefault(_es);

var _ar = require('date-fns/locale/ar');

var _ar2 = _interopRequireDefault(_ar);

var _it = require('date-fns/locale/it');

var _it2 = _interopRequireDefault(_it);

var _nl = require('date-fns/locale/nl');

var _nl2 = _interopRequireDefault(_nl);

var _th = require('date-fns/locale/th');

var _th2 = _interopRequireDefault(_th);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidDate = function isValidDate(period) {
  return R.and(_dateFns2.default.isDate, function (date) {
    return R.not(R.equals(date.getTime(date), NaN));
  })(new Date(period));
};

var dateWithoutTZ = exports.dateWithoutTZ = function dateWithoutTZ(date) {
  return _dateFns2.default.addMinutes(date, date.getTimezoneOffset());
};

var getLocale = exports.getLocale = R.cond([[R.equals('fr'), R.always(_fr2.default)], [R.equals('de'), R.always(_de2.default)], [R.equals('es'), R.always(_es2.default)], [R.equals('ar'), R.always(_ar2.default)], [R.equals('it'), R.always(_it2.default)], [R.equals('nl'), R.always(_nl2.default)], [R.equals('th'), R.always(_th2.default)], [R.T, R.always(_en2.default)]]);

var formaterPeriod = function formaterPeriod(locale, format) {
  return function (date) {
    return _dateFns2.default.format(date, format, { locale: getLocale(locale) });
  };
};

var getReportedTimePeriodLabel = exports.getReportedTimePeriodLabel = function getReportedTimePeriodLabel(freq, _format, locale) {
  return function (reportYearStart, _ref) {
    var id = _ref.id,
        start = _ref.start,
        reportedStart = _ref.reportedStart;

    var year = _dateFns2.default.getYear(start);
    var reportStartDate = new Date(year, reportYearStart.month, reportYearStart.day);
    var isReportFirstDate = _dateFns2.default.isEqual(reportStartDate, new Date(year, 1, 1));
    if (isReportFirstDate || freq === 'D') {
      return R.isNil(_format) || freq !== 'M' ? id : _dateFns2.default.format(start, _format, { locale: getLocale(locale) });
    }
    var nextYear = year + 1;
    if (freq === 'A') {
      return year + '/' + nextYear;
    }
    if (freq === 'S') {
      var _R$match = R.match(/S\d/, id),
          _R$match2 = (0, _slicedToArray3.default)(_R$match, 1),
          semester = _R$match2[0];

      return year + '/' + nextYear + '-' + semester;
    }
    if (freq === 'Q') {
      var _R$match3 = R.match(/Q\d/, id),
          _R$match4 = (0, _slicedToArray3.default)(_R$match3, 1),
          quarter = _R$match4[0];

      return year + '/' + nextYear + '-' + quarter;
    }
    if (freq === 'M') {
      var isFirstDayOfMonth = _dateFns2.default.isFirstDayOfMonth(reportedStart);
      if (isFirstDayOfMonth) {
        return R.isNil(_format) ? id : _dateFns2.default.format(reportedStart, _format, { locale: getLocale(locale) });
      }

      var _R$match5 = R.match(/M[\d]{2}/, id),
          _R$match6 = (0, _slicedToArray3.default)(_R$match5, 1),
          month = _R$match6[0];

      return year + '/' + nextYear + '-' + month;
    }

    var _R$match7 = R.match(/W[\d]{2}/, id),
        _R$match8 = (0, _slicedToArray3.default)(_R$match7, 1),
        week = _R$match8[0];

    return year + '/' + nextYear + '-' + week;
  };
};

var getReportedTimePeriod = exports.getReportedTimePeriod = function getReportedTimePeriod(reportYearStart, value, freq) {
  var start = new Date(R.prop('start', value));
  var end = dateWithoutTZ(new Date(R.prop('end', value)));
  if (reportYearStart.month === '01' && reportYearStart.day === '01') {
    return { start: start, end: end };
  }
  start = _dateFns2.default.addMonths(start, reportYearStart.month - 1);
  start = _dateFns2.default.addDays(start, reportYearStart.day - 1);
  if (freq === 'A') {
    end = _dateFns2.default.addYears(start, 1);
  }
  if (freq === 'S') {
    end = _dateFns2.default.addMonths(start, 6);
  }
  if (freq === 'Q') {
    end = _dateFns2.default.addMonths(start, 3);
  }
  if (freq === 'M') {
    end = _dateFns2.default.addMonths(start, 6);
  }
  if (freq === 'W' || freq === 'B') {
    end = _dateFns2.default.addDays(start, 7);
  }
  if (freq === 'D') {
    end = _dateFns2.default.addDays(start, 1);
  }
  if (freq === 'H') {
    end = _dateFns2.default.addHours(start, 1);
  }
  if (freq === 'N') {
    end = _dateFns2.default.addMinutes(start, 1);
  }
  end = _dateFns2.default.subSeconds(end, 1);
  return { start: start, end: end };
};

var getReportedTimePeriodNote = exports.getReportedTimePeriodNote = function getReportedTimePeriodNote(reportYearStart, start, end, freq) {
  if (reportYearStart.month === '01' && reportYearStart.day === '01') {
    return null;
  }
  if (R.includes(freq, ['D', 'H', 'N'])) {
    return null;
  }
  var isFirstDayOfMonth = _dateFns2.default.isFirstDayOfMonth(start);
  if (freq === 'M' && isFirstDayOfMonth) {
    return null;
  }
  var formatedStart = _dateFns2.default.format(start, 'YYYY-MM-DD');
  var formatedEnd = _dateFns2.default.format(end, 'YYYY-MM-DD');
  return { value: { name: formatedStart + ' - ' + formatedEnd } };
};

var getTimePeriodLabel = exports.getTimePeriodLabel = function getTimePeriodLabel(locale) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY MMM';
  return R.pipe(R.when(R.isNil, R.always('')), R.when(isValidDate, formaterPeriod(locale, format)));
};